$(document).ready(function() {

    $("li:first-child").addClass("first");
    $("li:last-child").addClass("last");

    $('[href="#"]').attr("href", "javascript:;");

    $(".menu-Bar").click(function() {
        $(this).toggleClass("open");
        $(".menuWrap").toggleClass("open");
        $("body").toggleClass("ovr-hiddn");
    });
  
  $("#close-menu").click(function() {
        $(".menu-Bar").toggleClass("open");
        $(".menuWrap").toggleClass("open");
        $("body").toggleClass("ovr-hiddn");
    });

  
      $(".tax-stockup-fixed").click(function() {
        $(".popup-tax").addClass('active');
    });
  
    $(".close-tax").click(function() {
        $(".popup-tax").removeClass('active');
    });

  
    /* Tabbing Function */
    $("[data-targetit]").on("click", function(e) {
        $(this).addClass("active");
        $(this)
            .siblings()
            .removeClass("active");
        var target = $(this).data("targetit");
        $("." + target)
            .siblings('[class^="box-"]')
            .hide();
        $("." + target).show()
        $(".index-slider").slick("setPosition", 0);
    });

   // Accordian
    $(".faq-accordian h4").click(function() {
        if (
            $(this)
            .parent("li")
            .hasClass("active")
        ) {
            $(this)
                .parent("li")
                .removeClass("active");
            $(this)
                .next()
                .slideUp();
        } else {
            $(".faq-accordian li").removeClass("active");
            $(this)
                .parent("li")
                .addClass("active");
            console.log("Doesnt have active");
            $(".faq-accordian li div").slideUp();
            $(this)
                .parent("li")
                .find("div")
                .slideDown();
        }
    });


  
  
     // Accordian new
    $(".accordian-support h4").click(function() {
        $(".accordian-support li").removeClass("active");
        $(this)
            .parent("li")
            .addClass("active");
        $(".accordian-support li div").slideUp();
        $(this)
            .parent("li")
            .find("div")
            .slideDown();
    });

  // Accordian product page
    $(".product-page-accordion-activator").click(function() {
    var $parentLi = $(this).parent();
    var $nextDiv = $(this).next();
    
    if ($parentLi.hasClass("active")) {
        // If already active, remove the active class and slide up
        $parentLi.removeClass("active");
        $nextDiv.slideUp();
    } else {
        // Close other accordions
        $(".product-page-accordions>li").removeClass("active");
        $(".product-page-accordions>li>div").slideUp();

        // Open the clicked accordion
        $parentLi.addClass("active");
        $nextDiv.slideDown();
    }
});

  

    var slider = $(".index-slider").slick({
        dots: true,
      arrows:false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
      autoplay:true,
      autoplaySpeed:5000,
      vertical:true,
      
            // prevArrow: $('.prev'),
            // nextArrow: $('.next')
    });

  
    $(".hero-slider-old").slick({
        dots: false,
      arrows:true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
      autoplay:true,
      autoplaySpeed:5000,
      vertical:false,
      prevArrow: "<button class='hero-slider-btn hero-slider-old-left'><i class='fa fa-chevron-left'></i></button>",
    nextArrow: "<button class='hero-slider-btn hero-slider-old-right'><i class='fa fa-chevron-right'></i></button>",
            // prevArrow: $('.prev'),
            // nextArrow: $('.next')
    });



      $(".hero-banner-slider-alts").slick({
        dots: true,
      arrows:false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
      autoplay:false,
      autoplaySpeed:5000,
      vertical:false,
      // prevArrow: "<button class='hero-slider-btn hero-slider-old-left'><i class='fa fa-chevron-left'></i></button>",
    // nextArrow: "<button class='hero-slider-btn hero-slider-old-right'><i class='fa fa-chevron-right'></i></button>",
            // prevArrow: $('.prev'),
            // nextArrow: $('.next')
    });

 
    


  let flagVideo = false;
  // Here is most important part of the code which actually stops the slider
slider.on('afterChange', function(event, slick, currentSlide){
  // slick - is a slider object with a lot of useful info
  // currentSlide - is a current slide index (starts from 0)
  if( slick.slideCount === currentSlide + 1 ){
    slick.paused = true;

    if(flagVideo == false){
      $('#hero-video')[0].play();
      flagVideo = true;
    }    
  }
});
  
  
    $(".tax-slider").slick({
        dots: true,
      arrows:false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
      autoplay:true,
      autoplaySpeed:5000,
            // prevArrow: $('.prev'),
            // nextArrow: $('.next')
    });
  
    $(".socials-slider").slick({
        dots: true,
      arrows:false,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
      autoplay:true,
      
      autoplaySpeed:1500,
            // prevArrow: $('.prev'),
            // nextArrow: $('.next')
    });
  




    //     Slider For
    // $('.slider-for').slick({
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     dots: false,
    //     arrows: false,
    //     fade: true,
    //     asNavFor: '.slider-nav'
    // });
    // $('.slider-nav').slick({
    //     slidesToShow: 4,
    //     slidesToScroll: 1,
    //     asNavFor: '.slider-for',
    //     dots: false,
    //     focusOnSelect: true
    // });

    /* Top Scroll */
    $('body').on('click', '#shop-scroll', function() {
        goToScroll('home-shop-sec');
    });

      $('body').on('click', '#shop-scroll2', function() {
        goToScroll('bg-pods-home-shop');
    });

    $('body').on('click', '#shop-scroll3', function() {
        goToScroll('elfbar-bundles-heading');
    });
  
  site_header = $('.site-header');
  header_class = 'site-header';
  
  $(window).scroll(function(){
        scroll = $(window).scrollTop();
        // get the height again cuz is getting 0 idk why
        header_height = document.getElementsByClassName(header_class)[0].clientHeight;
        if (scroll >= document.getElementById('warning-message').clientHeight) {
          site_header.css('position', 'fixed');
           site_header.css('boxShadow', '1px 1px 7px #0006');
          site_header.addClass('header-sticky');

        }
        else {
          site_header.css('position', 'relative');
           site_header.css('boxShadow', 'none');
                    site_header.removeClass('header-sticky');
        } 

      });
  
  
  $('.modal__toggle-open').on('click',function(){

    $('.modal__toggle-open').hide();
    $('.modal__toggle-close').show();
  })
  $('.modal__toggle-close').on('click',function(){

    $('.modal__toggle-close').hide();
    $('.modal__toggle-open').show();
  })
  
});


$(window).on("load", function() {
    var currentUrl = window.location.href.substr(
        window.location.href.lastIndexOf("/") + 1
    );


  $('.mega-menu-blogs-wrapper').show();
  
  // if(currentUrl == 'shop-elfbar-bc5000-disposable-vape')
  // {
  //   $("ul.menu li:nth-child(3)").addClass("active");
  // }
  //  else if(currentUrl == 'shop-elfbar-lowit-vape-pod-system')
  // {
  //   $("ul.menu li:nth-child(2)").addClass("active");
  // }
  // else if(currentUrl == 'hybrid')
  // {
  //   $("ul.menu li:nth-child(4)").addClass("active");
  // }
  //    else if(currentUrl == 'liquids')
  // {
  //   $("ul.menu li:nth-child(5)").addClass("active");
  // }
  // else if(currentUrl == 'shipping-refunds-and-warranty')
  // {
  //   $("ul.menu li:nth-child(6)").addClass("active");
  // }
  // else if(currentUrl == '')
  // {
  //   $("ul.menu li:nth-child(1)").addClass("active");
  // }

//embed widget additions


   $('body').on('click','.perk-widget-trigger',function(){    
     console.log("CLICKEITY");
      $('.widget-trigger').toggleClass("widget-trigger-activated");
      $('.peak-rewards-widget-page-main').toggleClass("widget-panel-active");
      
     // $('.peak-rewards-widget-page-main').fadeIn();   
   });



  //facebook share fix

          // Select the anchor tag
        var shareLink = $('.refferal-share-links li:nth-child(2) a');

        // Get the current onclick attribute
        var onclickAttr = shareLink.attr('onclick');

        // Extract the URL from the share function call
        var urlMatch = onclickAttr.match(/share\('([^']*)',''\);/);

        if (urlMatch && urlMatch[1]) {
            var url = urlMatch[1];

            // Remove any occurrences of 'https://'
            var newUrl = url.replace('https://', '');

            // Prepend 'https://' correctly
            newUrl = 'https://' + newUrl;

            // Construct the new onclick attribute
            var newOnclickAttr = "share('" + newUrl + "','');";

            // Update the onclick attribute
            shareLink.attr('onclick', newOnclickAttr);
        }
  
});



// window.addEventListener("resize", function() {


//Disposables
  //bc5000
  const shopImg = $('.shopeflbar-tab .hshop-img');
  const productIcons =  $('.shopeflbar-tab .product-lists-wrap');


//bc5000 new
  const shopImgbc5000 = $('.shopeflbar-tab-ELFBAR-BC5000 .hshop-img');
  const productIconsbc5000 =  $('.shopeflbar-tab-ELFBAR-BC5000 .product-lists-wrap');
//bc1000 new
  const shopImgbc1000 = $('.shopeflbar-tab-ELFBAR-BC1000 .hshop-img');
  const productIconsbc1000 =  $('.shopeflbar-tab-ELFBAR-BC1000 .product-lists-wrap');
//tE5000 new
  const shopImgte5000 = $('.shopeflbar-tab-ELFBAR-TE5000 .hshop-img');
  const productIconste5000 =  $('.shopeflbar-tab-ELFBAR-TE5000 .product-lists-wrap');
//bc5000 Ultra new
  const shopImgbc5000ultra = $('.shopeflbar-tab-ELFBAR-BC5000-ULTRA .hshop-img');
  const productIconsbc5000ultra =  $('.shopeflbar-tab-ELFBAR-BC5000-ULTRA .product-lists-wrap');
//bc10000 new
  const shopImgbc10000 = $('.shopeflbar-tab-ELFBAR-BC10000 .hshop-img');
  const productIconsbc10000 =  $('.shopeflbar-tab-ELFBAR-BC10000 .product-lists-wrap');
//gh20000 new
  const shopImgGH20000 = $('.shopeflbar-tab-ELFBAR-GH20000 .hshop-img');
  const productIconsGH20000 =  $('.shopeflbar-tab-ELFBAR-GH20000 .product-lists-wrap');
//af12000 new
  const shopImgAF12000 = $('.shopeflbar-tab-ELFBAR-AF12000 .hshop-img');
  const productIconsAF12000 =  $('.shopeflbar-tab-ELFBAR-AF12000 .product-lists-wrap');

//moonnight
  const shopImgMoonnight = $('.shopeflbar-tab-ELFBAR-MoonNight-70K .hshop-img');
  const productIconsMoonnight =  $('.shopeflbar-tab-ELFBAR-MoonNight-70K .product-lists-wrap');

//mixart
  const shopImgMixart = $('.shopeflbar-tab-ELFBAR-MixArt-40K .hshop-img');
  const productIconsMixart =  $('.shopeflbar-tab-ELFBAR-MixArt-40K .product-lists-wrap');

//prime new
  const shopImgPrime = $('.shopeflbar-tab-ELFBAR-Prime .hshop-img');
  const productIconsPrime =  $('.shopeflbar-tab-ELFBAR-Prime .product-lists-wrap');

//bc pro
  const shopImgBCPro = $('.shopeflbar-tab-ELFBAR-BC-Pro-80K .hshop-img');
  const productIconsBCPro =  $('.shopeflbar-tab-ELFBAR-BC-Pro-80K .product-lists-wrap');


//lowit 2500
 const shopImg2500 = $('.shop-elfbar-lowit-2500 .hshop-img');
  const productIcons2500 =  $('.shop-elfbar-lowit-2500 .product-lists-wrap');
//lowit 5500
 const shopImg5500 = $('.shop-elfbar-lowit-5500 .hshop-img');
  const productIcons5500 =  $('.shop-elfbar-lowit-5500 .product-lists-wrap');
  //lowit device
 const shopImgdevice = $('.shop-pod-devices .hshop-img');
  const productIconsdevice =  $('.shop-pod-devices .product-lists-wrap');

  //hybrid pods
  const shopImgHybridPods = $('.shopeflbar-tab-ELFBAR-EW9000-Pods .hshop-img');
  const productIconsHybridPods =  $('.shopeflbar-tab-ELFBAR-EW9000-Pods .product-lists-wrap');
//hybrid starter pack
  const shopImgHybridStarter = $('.shopeflbar-tab-ELFBAR-EW-Starter-Kits .hshop-img');
  const productIconsHybridStarter =  $('.shopeflbar-tab-ELFBAR-EW-Starter-Kits .product-lists-wrap');
//hybrid powerbank
  const shopImgHybridPB = $('.shopeflbar-tab-EW9000-Power-Bank-QS .hshop-img');
  const productIconsHybridPB =  $('.shopeflbar-tab-EW9000-Power-Bank-QS .product-lists-wrap');

//hybrid 25000 pods
  const shopImgHybridPods25000 = $('.shopeflbar-tab-ELFBAR-EW25000-Pods .hshop-img');
  const productIconsHybridPods25000 =  $('.shopeflbar-tab-ELFBAR-EW25000-Pods .product-lists-wrap');
//hybrid 25000 powerbank
  const shopImgHybridPB25000 = $('.shopeflbar-tab-ELFBAR-EW-Power-Banks .hshop-img');
  const productIconsHybridPB25000 =  $('.shopeflbar-tab-ELFBAR-EW-Power-Banks .product-lists-wrap');

  if ($(window).width() < 767) {

   //   $(".discount-ticker").slick({
   //      dots: false,
   // arrows:false,
   //      infinite: true,
   //      speed: 300,
   //      slidesToShow: 1,
   // autoplay:true,
   
   //            responsive: [
   //  	{
   //        breakpoint: 825,
   //        settings: {

   //          useTransform:false,
   //        }
   //      }
   //       ]
   //  });


    $(".howtouse-fourinone-items").slick({
        dots: true,
      arrows:false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
      autoplay:true
    });

    
    
    console.log("going into mobile");

    //for bc5000
    $(shopImg).insertAfter( ".shopeflbar-tab #hshop-title" );
    $(productIcons).insertAfter( ".shopeflbar-tab .home-shop-text p" );

    //for lowit 2500
 $(shopImg2500).insertAfter( ".shop-elfbar-lowit-2500 #hshop-title" );
    $(productIcons2500).insertAfter( ".shop-elfbar-lowit-2500 .home-shop-text p" );

    //for lowit 5500
 $(shopImg5500).insertAfter( ".shop-elfbar-lowit-5500 #hshop-title" );
    $(productIcons5500).insertAfter( ".shop-elfbar-lowit-5500 .home-shop-text p" );

    //for lowit device
 $(shopImgdevice).insertAfter( ".shop-pod-devices #hshop-title" );
    $(productIconsdevice).insertAfter( ".shop-pod-devices .home-shop-text p" );

//Disposables Quick Shop mobile
    //for bc5000
    $(shopImgbc5000).insertAfter( ".shopeflbar-tab-ELFBAR-BC5000 #hshop-title" );
    $(productIconsbc5000).insertAfter( ".shopeflbar-tab-ELFBAR-BC5000 .home-shop-text p" );
 //for bc1000
    $(shopImgbc1000).insertAfter( ".shopeflbar-tab-ELFBAR-BC1000 #hshop-title" );
    $(productIconsbc1000).insertAfter( ".shopeflbar-tab-ELFBAR-BC1000 .home-shop-text p" );
 //for te5000
    $(shopImgte5000).insertAfter( ".shopeflbar-tab-ELFBAR-TE5000 #hshop-title" );
    $(productIconste5000).insertAfter( ".shopeflbar-tab-ELFBAR-TE5000 .home-shop-text p" );
 //for bc5000 ultra
    $(shopImgbc5000ultra).insertAfter( ".shopeflbar-tab-ELFBAR-BC5000-ULTRA #hshop-title" );
    $(productIconsbc5000ultra).insertAfter( ".shopeflbar-tab-ELFBAR-BC5000-ULTRA .home-shop-text p" );
 //for bc10000 
    $(shopImgbc10000).insertAfter( ".shopeflbar-tab-ELFBAR-BC10000 #hshop-title" );
    $(productIconsbc10000).insertAfter( ".shopeflbar-tab-ELFBAR-BC10000 .home-shop-text p" );


     //for GH20000
    $(shopImgGH20000).insertAfter( ".shopeflbar-tab-ELFBAR-GH20000 #hshop-title" );
    $(productIconsGH20000).insertAfter( ".shopeflbar-tab-ELFBAR-GH20000 .home-shop-text p" );
    

      //for moonnight
    $(shopImgMoonnight).insertAfter( ".shopeflbar-tab-ELFBAR-MoonNight-70K #hshop-title" );
    $(productIconsMoonnight).insertAfter( ".shopeflbar-tab-ELFBAR-MoonNight-70K .home-shop-text p" );
    
  //for mixart
    $(shopImgMixart).insertAfter( ".shopeflbar-tab-ELFBAR-MixArt-40K #hshop-title" );
    $(productIconsMixart).insertAfter( ".shopeflbar-tab-ELFBAR-MixArt-40K .home-shop-text p" );

     //for af20000
    $(shopImgAF12000).insertAfter( ".shopeflbar-tab-ELFBAR-AF12000 #hshop-title" );
    $(productIconsAF12000).insertAfter( ".shopeflbar-tab-ELFBAR-AF12000 .home-shop-text p" );

   
     //for prime
    $(shopImgPrime).insertAfter( ".shopeflbar-tab-ELFBAR-Prime #hshop-title" );
    $(productIconsPrime).insertAfter( ".shopeflbar-tab-ELFBAR-Prime .home-shop-text p" );



     //for bc pro
    $(shopImgBCPro).insertAfter( ".shopeflbar-tab-ELFBAR-BC-Pro-80K #hshop-title" );
    $(productIconsBCPro).insertAfter( ".shopeflbar-tab-ELFBAR-BC-Pro-80K .home-shop-text p" );


        //for hybrid starter pack
  $(shopImgHybridStarter).insertAfter( ".shopeflbar-tab-ELFBAR-EW-Starter-Kits #hshop-title" );
    $(productIconsHybridStarter).insertAfter( ".shopeflbar-tab-ELFBAR-EW-Starter-Kits .home-shop-text p" );

   //for hybrid powerbank
     $(shopImgHybridPB).insertAfter( ".shopeflbar-tab-EW9000-Power-Bank-QS #hshop-title" );
    $(productIconsHybridPB).insertAfter( ".shopeflbar-tab-EW9000-Power-Bank-QS .home-shop-text p" );

    //for hybrid pods
  $(shopImgHybridPods).insertAfter( ".shopeflbar-tab-ELFBAR-EW9000-Pods #hshop-title" );
    $(productIconsHybridPods).insertAfter( ".shopeflbar-tab-ELFBAR-EW9000-Pods .home-shop-text p" );

     //for 25000 hybrid pods
  $(shopImgHybridPods25000).insertAfter( ".shopeflbar-tab-ELFBAR-EW25000-Pods #hshop-title" );
    $(productIconsHybridPods25000).insertAfter( ".shopeflbar-tab-ELFBAR-EW25000-Pods .home-shop-text p" );

    //for 25000 hybrid powerbank
     $(shopImgHybridPB25000).insertAfter( ".shopeflbar-tab-ELFBAR-EW-Power-Banks #hshop-title" );
    $(productIconsHybridPB25000).insertAfter( ".shopeflbar-tab-ELFBAR-EW-Power-Banks .home-shop-text p" );




//elfbar video mobile

    $("#hero-video").attr("data-src","https://cdn.shopify.com/videos/c/o/v/5fe24788ec7e48fc97f4a66ef5571387.mp4");
}
  
  function goToScroll(e) {
  $("html, body").animate(
    {
      scrollTop: $("." + e).offset().top - 135,
    },
    1000
  );
}
  
// }); 




var lazyLoadInstance = new LazyLoad({
  // Your custom settings go here
});

 // Accordian new




// const scrollWrapper = document.querySelector('.quick-shop-collections-holder');
// const prevButton = document.getElementById('qs-prev-btn');
// const nextButton = document.getElementById('qs-next-btn');

// let scrollAmount = 0;

// // Initially hide the prevButton
// prevButton.style.display = 'none';

// nextButton.addEventListener('click', function () {
//   console.log("Next Click");
//   scrollAmount += 200; // Adjust the scroll amount as needed

//   // Scroll to the updated position
//   scrollWrapper.scrollTo({
//     top: 0,
//     left: scrollAmount,
//     behavior: 'smooth'
//   });

//   // Show the prevButton after the first click
//   if (scrollAmount > 0) {
//     prevButton.style.display = 'block';
//   }

//   // Check if nextButton has reached the end, then hide it
//   const maxScroll = scrollWrapper.scrollWidth - scrollWrapper.clientWidth;
//   if (scrollAmount >= maxScroll) {
//     nextButton.style.display = 'none !important';
//   }
// });

// prevButton.addEventListener('click', function () {
//   scrollAmount -= 200; // Adjust the scroll amount as needed

//   // Scroll to the updated position
//   scrollWrapper.scrollTo({
//     top: 0,
//     left: scrollAmount,
//     behavior: 'smooth'
//   });

//   // Show the nextButton if it was hidden
//   nextButton.style.display = 'block';

//   // Hide the prevButton if at the beginning
//   if (scrollAmount <= 0) {
//     prevButton.style.display = 'none';
//   }
// });
   
